// Ziyaretci tarafinda sunucu okunmamis verisi yok; son karsi-taraf mesaji lastRead ile karsilastirilir.
const OTHER_SIDE = (m) => m && m.messageType && m.messageType !== "visitor" && !String(m.messageType).startsWith("visitor-") && m.messageType !== "system";
function lastMessageTime(chat) {
    const times = ((chat && chat.messages) || []).filter(OTHER_SIDE).map((m) => Date.parse(m.createdDate)).filter((t) => !isNaN(t));
    return times.length ? Math.max(...times) : 0;
}
function isUnread(chat, lastReadMap) {
    const t = lastMessageTime(chat);
    if (!t) return false;
    const read = (lastReadMap || {})[chat._id] || 0;
    return t > read;
}
function countUnread(conversations, lastReadMap) {
    return (conversations || []).filter((c) => isUnread(c, lastReadMap)).length;
}
module.exports = { lastMessageTime, isUnread, countUnread };



// WEBPACK FOOTER //
// ./src/utils/shell/unread.js